export const version = "abi/5.3.1";
//# sourceMappingURL=_version.js.map